/**
 * Existen algunos eventos que se disparan en la
 * aplicación con la finalidad de desencadenar
 * un comportamiento específico. Por ello se declaran
 * las siguientes constantes.
 */
export const customEvents = {
  /**
   * Indica que un elemento necesita recibir el foco,
   * de esta forma, elementos que no se están mostrando
   * en pantalla (por display:none por ejemplo), pueden
   * indicar a sus ancestros que deben expandirse.
   */
  focus: 'customFocus',
  /**
   * Indica que debe cambiarse el título del modal
   */
  iframeModalChangeTitle: 'iframeModalChangeTitle',
  /**
   * Indica que un iframe modal debe cerrarse
   */
  iframeModalClose: 'iframeModalClose',
  /**
   * Indica que un iframe modal debe cerrarse
   */
  iframeModalNotify: 'iframeModalNotify',
  /**
   * Indica que un modal debe cerrarse
   */
  modalClose: 'modalClose',
  /**
   * Indica que el panel contenedor debe cerrarse porque
   * está vacío
   */
  hidePanel: 'hidePanel',
  showPanel: 'showPanel',
  /**
   * Evento lanzado por formsEventsController sobre window
   * cuando se termina de procesar los formularios de la tarea
   */
  formsReady: 'formsReady',
};
